import React, { useState } from "react";
import { Button, Tip } from "grommet";
import { Refresh } from "grommet-icons";
import { GuestService } from "@services";
import {
  presentToastSuccess,
  presentToastErrorContent,
  presentToastWarning,
} from "@shared/Toast";

const CheckKeyUsedButton = ({ bookingId, disabled, onDetected }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);
      const response = await GuestService.checkKeyUsed(bookingId);
      if (response.data.updated) {
        presentToastSuccess("Door entry detected — status updated to key used");
        onDetected?.();
      } else {
        presentToastWarning("No passcode / keycard entry found yet");
      }
    } catch (error) {
      presentToastErrorContent(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tip
      content={disabled ? "Check-in date not reached yet" : "Check door entry"}
    >
      <Button
        icon={<Refresh color="white" size="small" />}
        onClick={handleClick}
        disabled={loading || disabled}
        color="neutral-2"
        primary
      />
    </Tip>
  );
};

export default CheckKeyUsedButton;
